import Formatter from './Formatter';
import Helpers from './Helpers';
import Utils from './Utils';


const formatter = new Formatter;
const helpers = new Helpers;
const utils = new Utils;

const ReportByReactivationComponent = {
    formatter,

    getParams: helpers.getParams,

    utils: utils
};

export default ReportByReactivationComponent;
